import fetch$1 from 'cross-fetch';
import { isObject } from 'lodash';
import * as qs from 'query-string';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const validateUserInfo = props => {
  let valid = true;
  let reason = '';
  const {
    locale,
    visitorId,
    userId
  } = props || {};

  switch (true) {
    case !locale:
      {
        valid = false;
        reason = '[XS] `locale` is missing.';
        break;
      }

    case !visitorId && !userId:
      {
        valid = false;
        reason = '[XS] `vistorId` & `userId is missing. Please provide either or both';
        break;
      }
  }

  return {
    valid,
    reason
  };
};

const CONTENT_TYPE = 'Content-Type';
const APPLICATION_JSON = 'application/json';
function fetch (url, options = {}) {
  const {
    params,
    body,
    headers = {}
  } = options,
        requestOptions = __rest(options, ["params", "body", "headers"]);

  const hasBody = body && isObject(options.body);
  const finalBody = hasBody ? JSON.stringify(body) : body;
  const finalHeaders = hasBody ? Object.assign(Object.assign({}, headers), {
    [CONTENT_TYPE]: APPLICATION_JSON
  }) : headers;
  const finalUrl = params ? `${url}?${qs.stringify(params)}` : url;
  return fetch$1(finalUrl, Object.assign(Object.assign({}, requestOptions), {
    body: finalBody,
    headers: finalHeaders
  }));
}

function getOptions(method, options = {}) {
  const {
    body
  } = options,
        extra = __rest(options, ["body"]);

  const requestOptions = Object.assign({
    method
  }, extra);

  if (body) {
    Object.assign(requestOptions, {
      body
    });
  }

  return requestOptions;
}

const serviceCaller = baseUrl => ({
  get: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('GET', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = yield response.json();
    return data;
  }),
  put: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('PUT', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = yield response.json();
    return data;
  }),
  patch: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('PATCH', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = yield response.json();
    return data;
  }),
  post: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('POST', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = response.status === 204 ? {} : yield response.json();
    return data;
  })
});

const fetchAllExperiments = props => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const {
      baseUrl
    } = props;
    const fetcher = serviceCaller(baseUrl);
    const path = '/xs/all-variations';
    const res = yield fetcher.get(path, {});
    return res;
  } catch (e) {
    console.error('[XS] *************Unable to load all experiments*************');
    throw e;
  }
});
const fetchUserExperiments = props => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const {
      baseUrl,
      user,
      filters
    } = props;
    const fetcher = serviceCaller(baseUrl);
    let params = user;
    const path = '/xs/variation';

    if (filters) {
      params = Object.assign(Object.assign({}, params), filters);
    }

    const res = yield fetcher.get(path, {
      params
    });
    return res;
  } catch (e) {
    console.error("[XS] *************Unable to load user's experiments*************");
    throw e;
  }
});
const exposeExperiment = props => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const {
      baseUrl,
      payload
    } = props;
    const fetcher = serviceCaller(baseUrl);
    const path = '/xs/exposure';
    yield fetcher.post(path, {
      body: payload
    });
  } catch (e) {
    console.error('[XS] *************Unable to expose experiments*************');
    throw e;
  }
});

var XSEvents;

(function (XSEvents) {
  XSEvents["PRE_EXPERIMENTS_LOAD"] = "PRE_EXPERIMENTS_LOAD";
  XSEvents["POST_EXPERIMENTS_LOAD"] = "POST_EXPERIMENTS_LOAD";
  XSEvents["PRE_EXPOSURE"] = "PRE_EXPOSURE";
  XSEvents["POST_EXPOSURE"] = "POST_EXPOSURE";
})(XSEvents || (XSEvents = {}));

class EventEmitter {
  constructor() {
    this.events = {};

    this.emit = (name, ...args) => {
      const events = this.events[name];

      if (events && events.length > 0) {
        for (const cb of events) {
          cb(...args);
        }
      }
    };

    this.on = (name, cb) => {
      if (!this.events[name]) {
        this.events[name] = [];
      }

      this.events[name].push(cb);
    };
  }

}

class PluginManager extends EventEmitter {
  constructor(props) {
    super();

    this.registerEvents = () => {
      this.plugins.forEach(plugin => {
        if (plugin.beforeExperimentsLoad) {
          this.on(XSEvents.PRE_EXPERIMENTS_LOAD, plugin.beforeExperimentsLoad);
        }

        if (plugin.beforeExposure) {
          this.on(XSEvents.PRE_EXPOSURE, plugin.beforeExposure);
        }

        if (plugin.onExperimentsLoad) {
          this.on(XSEvents.POST_EXPERIMENTS_LOAD, plugin.onExperimentsLoad);
        }

        if (plugin.onExposure) {
          this.on(XSEvents.POST_EXPOSURE, plugin.onExposure);
        }
      });
    };

    this.plugins = props.plugins || [];
    this.registerEvents();
  }

}

/**
 * @class XS
 *
 * @param props {@link XSProps}
 * @returns {@link default}
 */

class XS {
  constructor(props) {
    this.exposedExperiments = {};
    this.experiments = {};
    this.rawExperiments = {
      variations: []
    };
    this.allExperiments = [];
    this.normalizedAllExperiments = {};
    /**
     * Method to default to empty experiments. So that the instance is ready.
     * This helps incase the instacne failed to load experiments, we don't want to break the clients of the SDK or throw errors.
     *
     * @function defaultToEmptyExperiments
     * @private
     * @returns void
     */

    this.defaultToEmptyExperiments = () => {
      this.rawExperiments = {
        variations: []
      };
      this.experiments = {};
      this.allExperiments = [];
      this.normalizedAllExperiments = {};
      this.isReadyPromiseResolver();
    };
    /**
     * Set an experiment as exposed
     *
     * @function setExposure
     * @returns adds the experiment to the exposed experiments
     */


    this.setExposure = experimentId => {
      this.exposedExperiments[experimentId] = true;
    };
    /**
     * Check if an experiment is aleady exposed
     *
     * @function getExposure
     * @returns returns true if the experiment is exposed
     */


    this.getExposure = experimentId => {
      return this.exposedExperiments[experimentId];
    };
    /**
     * Get promise that resolves when the instance is ready
     *
     * @function onReady
     * @returns a promise that resolves when the instance is ready
     */


    this.onReady = () => {
      return this.isReadyPromise;
    };
    /**
     * Check if the instance has valid experiments
     *
     * @function  hasValidExperiments
     * @returns true if the instance has valid experiments
     */


    this.hasValidExperiments = () => {
      return this.rawExperiments.variations.length > 0;
    };
    /**
     * Sets the user for the XS instance.
     * If user experiments are already loaded, then the instance ready promise will be resolved.
     *
     * @function setUser
     * @param user - user details
     * @returns void
     */


    this.setUser = user => {
      if (user) {
        const {
          valid,
          reason
        } = validateUserInfo(user);

        if (!valid) {
          console.warn('[XS] User info is invalid: ', reason);
          console.warn('[XS] Instance will not fetch experiments or register exposure until valid user info is provided');
          return;
        }

        this.user = user;

        if (this.rawExperiments.variations.length) {
          this.isReadyPromiseResolver();
        }
      }
    };
    /**
     * Loads user experiments.
     * If the user prop is already set, then the instance ready promise will be resolved
     *
     * @function loadExperiments
     * @param experiments - raw user experiments
     * @returns Normalized user experiments
     */


    this.loadExperiments = experiments => {
      this.pluginsManager.emit(XSEvents.PRE_EXPERIMENTS_LOAD);
      this.rawExperiments = experiments;
      this.experiments = XS.normalizeUserExperiments(this.rawExperiments);

      if (this.user) {
        this.isReadyPromiseResolver();
      }

      this.pluginsManager.emit(XSEvents.POST_EXPERIMENTS_LOAD);
      return this.experiments;
    };
    /**
     * Get the experiment for a given experiment id.
     *
     * @function getExperiment
     * @param id -  experiment id
     * @returns The mapped user experiment details.
     */


    this.getExperiment = id => {
      return this.experiments[id];
    };
    /**
     * Get all of the user experiments without normalization.
     *
     * @function getRawUserExperiments
     * @returns raw user experiments
     */


    this.getRawUserExperiments = () => {
      return this.rawExperiments;
    };
    /**
     * Get the bucketed variation name for a given experiment id.
     *
     * @function getVariation
     * @param id - experiment id
     * @returns
     */


    this.getVariation = id => {
      var _a;

      return (_a = this.experiments[id]) === null || _a === void 0 ? void 0 : _a.variationName;
    };
    /**
     * Get the bucketed variation attributes for a given experiment id.
     *
     * @function getAttributes
     * @param id - experiment id
     * @returns Mapped variation attributes
     */


    this.getAttributes = id => {
      var _a;

      return (_a = this.experiments[id]) === null || _a === void 0 ? void 0 : _a.attributes;
    };
    /**
     * Get the bucketed variation attribute for a given experiment id & attribute name.
     *
     * @function getAttribute
     * @param id - experiment id
     * @returns value of the mapped attribute
     */


    this.getAttribute = (id, attributeName) => {
      var _a, _b;

      return (_b = (_a = this.experiments[id]) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b[attributeName];
    };
    /**
     * Fetch bucketed user experiments, variation and attributes.
     * Sets & resolves with default values when the API call fails.
     * This decreased the chances of unhandled promise rejections for the SDK users.
     *
     * @function fetchAllExperiments
     * @returns normalized user experiments
     */


    this.fetchUserExperiments = () => __awaiter(this, void 0, void 0, function* () {
      if (!this.user) {
        console.warn('[XS] No user set. Defaulting to empty experiments.');
        this.defaultToEmptyExperiments();
        return this.experiments;
      }

      try {
        this.pluginsManager.emit(XSEvents.PRE_EXPERIMENTS_LOAD);
        this.rawExperiments = yield XS.fetchUserExperiments(this.baseUrl, this.user, this.filters);
        this.experiments = XS.normalizeUserExperiments(this.rawExperiments);
        this.isReadyPromiseResolver();
        this.pluginsManager.emit(XSEvents.POST_EXPERIMENTS_LOAD);
        return this.experiments;
      } catch (e) {
        console.error('[XS] Failed to fetch user experimentsx', e);
        this.defaultToEmptyExperiments();
        return this.experiments;
      }
    });
    /**
     * Fetch bucketed user experiments, variation and attributes.
     * Resolves with empty object when the API call fails.
     * This decreased the chances of unhandled promise rejections for the SDK users.
     *
     * @function fetchExperiments
     * @returns normalized experiments
     */


    this.fetchExperiments = () => __awaiter(this, void 0, void 0, function* () {
      try {
        this.allExperiments = yield XS.fetchExperiments(this.baseUrl);
        this.normalizedAllExperiments = XS.normalizeExperiments(this.allExperiments);
        return this.normalizedAllExperiments;
      } catch (e) {
        console.error('[XS] Failed to fetch user experimentsx', e);
        return {};
      }
    });
    /**
     * Register Exposure for a given experiment id.
     * If the experiment is not found in the instance map, then exposure is skipped.
     * If the experiment is already exposed, then exposure is skipped.
     * If the exposure was successful, then the experiment is marked as exposed in the internal cache.
     * Resolves even if the API call fails.
     *
     * @function fetchExperiments
     * @returns normalized experiments
     */


    this.exposeExperiment = id => __awaiter(this, void 0, void 0, function* () {
      try {
        if (!this.user) {
          console.warn('[XS] No user set. Aborting experiment exposure.');
          return;
        }

        const experiment = this.experiments[id];

        if (!experiment) {
          console.warn(`[XS] No experiment found for id: ${id}. Skipping exposure.`);
          return;
        }

        const isAlreadyExposed = this.getExposure(id);

        if (isAlreadyExposed) {
          console.warn(`[XS] Experiment ${id} already exposed. Skipping exposure.`);
          return;
        }

        this.pluginsManager.emit(XSEvents.PRE_EXPOSURE, experiment);
        const {
          experimentId,
          variationId
        } = this.experiments[id];
        yield XS.exposeExperiment(this.baseUrl, Object.assign(Object.assign({}, this.user), {
          experimentId,
          variationId
        }));
        this.pluginsManager.emit(XSEvents.POST_EXPOSURE, experiment);
        this.setExposure(id);
      } catch (e) {
        console.error('[XS] Failed to expose experiment', e);
      }
    });

    const {
      baseUrl = 'https://api.ww.com',
      experiments,
      user,
      filters
    } = props || {}; // eslint-disable-next-line @typescript-eslint/no-empty-function

    this.isReadyPromiseResolver = () => {};

    this.isReadyPromise = new Promise(resolve => {
      this.isReadyPromiseResolver = resolve;
    });
    this.baseUrl = baseUrl;
    this.filters = filters;
    this.pluginsManager = new PluginManager({
      plugins: props === null || props === void 0 ? void 0 : props.plugins
    });
    this.setUser(user);

    if (experiments) {
      try {
        this.loadExperiments(experiments);
      } catch (_a) {
        this.defaultToEmptyExperiments();
      }
    }
  }

  static fetchUserExperiments(baseUrl, user, filters) {
    return __awaiter(this, void 0, void 0, function* () {
      const data = yield fetchUserExperiments({
        baseUrl,
        user,
        filters
      });
      return data;
    });
  }

  static fetchExperiments(baseUrl) {
    return __awaiter(this, void 0, void 0, function* () {
      const data = yield fetchAllExperiments({
        baseUrl
      });
      return data;
    });
  }

  static exposeExperiment(baseUrl, payload) {
    return __awaiter(this, void 0, void 0, function* () {
      yield exposeExperiment({
        baseUrl,
        payload
      });
    });
  }

  static normalizeUserExperiments(data) {
    return data.variations.reduce((accu, experiment) => {
      const {
        experimentTextId,
        experimentId,
        experimentName,
        variationId,
        variationName
      } = experiment;
      const attributes = experiment.attribute.reduce((accu, attribute) => {
        const {
          attributeName,
          attributeValue
        } = attribute;
        accu[attributeName] = attributeValue;
        return accu;
      }, {});
      accu[experimentTextId] = {
        experimentId,
        experimentTextId,
        experimentName,
        variationId,
        variationName,
        attributes
      };
      return accu;
    }, {});
  }

  static normalizeExperiments(data) {
    return data.reduce((accu, experiment) => {
      const {
        experimentTextId
      } = experiment;
      const variations = experiment.variations.reduce((accu, variation) => {
        const {
          variationName
        } = variation;
        const attributes = variation.attributes.reduce((accu, attribute) => {
          const {
            attributeName
          } = attribute;
          accu[attributeName] = attribute;
          return accu;
        }, {});
        accu[variationName] = Object.assign(Object.assign({}, variation), {
          attributes
        });
        return accu;
      }, {});
      accu[experimentTextId] = Object.assign(Object.assign({}, experiment), {
        variations
      });
      return accu;
    }, {});
  }

}

export { XS as default };
